<template>
    <div class="container">
        <vue-headful
                title="Departments - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="">
                                <router-link :to="{name : 'website-departments-add'}" class="btn my-4 btn-primary">
                                    ADD Departments
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">Department ID</th>
                                <th scope="col">Title</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="department in DepartmentsDetails" :key="department.id">
                                <td>
                                    <button @click="deleteDepartment(department.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Department"></button>
                                    <router-link :to="{name : 'website-departments-update', params: {department_id: department.id}}" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Department"></router-link>
                                </td>
                                <td scope="row">
                                    <strong>{{department.id}}</strong>
                                </td>
                                <td v-html="department.department">
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      DepartmentsDetails: {}
    };
  },
  methods: {
    wip: function() {
      alert("Work in progress");
    },
    goNew: function() {
      window.location.href = "/dashboard/website/departments/new";
    },
    get_Departments() {
      axios({
        url:
          "admin/sus-team/department/all" +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.DepartmentsDetails = result.data.department;
            console.log(result.data.department);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteDepartment(id) {
      axios({
        method: "delete",
        url:
          "admin/sus-team/department/delete/" +
          id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Department Deleted Successfully", "", "success");
            this.get_Departments();
            result;
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_Departments();
  }
};
</script>
<style>
</style>
